//import 'bootstrap/dist/css/bootstrap.css';
import '_helpers/polyfills'
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { history } from '_helpers';
import configureStore from '_helpers/store';
import { App } from 'App';
import * as serviceWorker from '_services/serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'Site.css'
import "react-datepicker/dist/react-datepicker.css";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);
root.render(
    <Provider store={store}>
        <Router history={history}>
            <MsalProvider instance={msalInstance}>
                <App />
            </MsalProvider>
        </Router>
    </Provider>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// serviceWorker.register({
//     onUpdate: registration => {
//         alert('New version available!  Ready to update?');
//         if (registration && registration.waiting) {
//           registration.waiting.postMessage({ type: 'SKIP_WAITING' });
//         }
//         window.location.reload();
//       }
// });
